import * as _ from "lodash";

import { Input, Select } from "@/components";
import { Map } from "@/utils";

import SettingsTab from "../Tab";

const renderContent = ({ model, changeFormState, FormControl }) => {
    const ceilingTypesOptions = _.map(
        Map.Collections.ceilingTypes,
        (positionType) => ({
            value: positionType,
            label: positionType,
        }),
    );

    const renderCeilingTileSizeSelect = () => {
        const tileSizesOptions = _.map(
            Map.Collections.tileSizes,
            (tileSize, name) => ({
                value: tileSize,
                label: name,
            }),
        );

        const { tileSizeX, tileSizeY } = model;

        let selectedTileSize = _.find(tileSizesOptions, (tileSize) =>
            _.isEqual(tileSize.value, { tileSizeX, tileSizeY }),
        );

        if (!selectedTileSize) {
            selectedTileSize = tileSizesOptions[0];
        }

        return (
            <FormControl className="col-sm-4" name="tileSize">
                <label className="selectLabel">Ceiling Tile Size (feet)</label>
                <Select
                    value={selectedTileSize.value}
                    options={tileSizesOptions}
                    onChange={({ value }) => !!value && changeFormState(value)}
                />
            </FormControl>
        );
    };

    const renderCeilingTileSizeCustom = () => {
        return [
            <FormControl className="col-sm-3" key={1} name="tileSizeX">
                <Input
                    value={model.tileSizeX}
                    label="Custom X (feet)"
                    onChange={(value) =>
                        changeFormState({
                            tileSizeX: value,
                        })
                    }
                    type="number"
                />
            </FormControl>,
            <FormControl className="col-sm-3" key={2} name="tileSizeY">
                <Input
                    value={model.tileSizeY}
                    label="Custom Y (feet)"
                    onChange={(value) =>
                        changeFormState({
                            tileSizeY: value,
                        })
                    }
                    type="number"
                />
            </FormControl>,
        ];
    };

    return (
        <div>
            <div className="row">
                <FormControl className="col-sm-4" name="type" required>
                    <label className="selectLabel">
                        Ceiling Type<span className="asterisk">*</span>
                    </label>
                    <Select
                        value={model.type}
                        onChange={({ value }) =>
                            !!value &&
                            changeFormState({
                                ...model,
                                type: value,
                            })
                        }
                        options={ceilingTypesOptions}
                    />
                </FormControl>
            </div>
            <div className="row">
                {model.type === Map.Collections.ceilingTypes[0]
                    ? renderCeilingTileSizeSelect()
                    : renderCeilingTileSizeCustom()}
                <FormControl className="col-sm-3" name="gridOffSetX">
                    <Input
                        label="Grid Offset X (feet)"
                        value={model.gridOffSetX}
                        onChange={(value) =>
                            changeFormState({
                                gridOffSetX: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
                <FormControl className="col-sm-3" name="gridOffSetY">
                    <Input
                        label="Grid Offset Y (feet)"
                        value={model.gridOffSetY}
                        onChange={(value) =>
                            changeFormState({
                                gridOffSetY: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
            </div>
        </div>
    );
};

/**
 * Settings tab for configuring ceiling grid properties.
 *
 * @param props - The settings tab props including model and form state.
 * @returns The rendered ceiling settings tab.
 */
const CeilingTab = (props) => (
    <SettingsTab {...props} renderContent={renderContent} />
);

export default CeilingTab;
